import React from 'react';
import { Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Container from '@/components/Container';
import { useStore } from '@/components/store/Store';
import { SettingsMenu } from '@/components/SettingsMenu';

export const AdminLayout = () => {
  const {
    state: { currentUser },
  } = useStore();
  const isSuperAdmin = currentUser?.user?.is_super_admin;
  const menuItems = [
    { path: '/m24admin', label: 'Admin Dashboard' },
    { path: '/m24admin/owners', label: 'Museer og nettsteder' },
    { path: '/m24admin/sites', label: 'Nettsteder og domener' },
    { path: '/m24admin/design', label: 'Stilsett' },
    { path: '/m24admin/statistics', label: 'Statistikk' },
    { path: '/m24admin/analyze', label: 'Analyse og  rapporter' },
    { path: '/m24admin/superadmins', label: 'Superadmin-brukere' },
    { path: '/m24admin/tools', label: 'Verktøy' },
    { path: '/m24admin/test-tools', label: 'Testverktøy' },
  ];

  return (
    <>
      <Container
        p={4}
        pl={3}
        fullWidth
        fullHeight
        column
        gap={0}
        top
        sx={{
          margin: '0 auto',
        }}>
        {isSuperAdmin && (
          <Container fullWidth top fullHeight>
            <Container sx={{ width: '250px' }} column left>
              <Typography
                sx={{
                  fontSize: '1rem',
                  fontWeight: 600,
                }}>
                Museum24 ADMIN
              </Typography>
              <SettingsMenu menuItems={menuItems} />
            </Container>
            <Container fullWidth left p={3} top fullHeight sx={{ overflowY: 'auto' }}>
              <Outlet />
            </Container>
          </Container>
        )}
        {!isSuperAdmin && (
          <Container fullWidth fullHeight>
            <Typography sx={{ fontSize: '1.5rem' }}>Du har ikke tilgang til denne siden</Typography>
          </Container>
        )}
      </Container>
    </>
  );
};
